import React from 'react';
import { useTranslation } from 'react-i18next';
import './ReconnectBar.scss';

interface ReconnectBarProps {
    onReconnect: () => void;
    isConnecting?: boolean;
}

const ReconnectBar: React.FC<ReconnectBarProps> = ({ onReconnect, isConnecting }) => {
    const { t } = useTranslation();

    return (
        <div className={`reconnect-bar ${isConnecting ? 'connecting' : ''}`}>
           <div className="reconnect-message">
                {t('common.connectionLostRetry')}
           </div>
           <button
                type="button"
                className="reconnect-retry-btn"
                onClick={onReconnect}
                disabled={isConnecting}
                aria-busy={isConnecting}
            >
                {t('common.retry')}
           </button>
        </div>
    );
};

export default ReconnectBar;
